console.log('cart.js')

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      console.log('remove button', event)
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

class MinusButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      console.log('minus button', event)
      event.preventDefault();
      const quantityInput = this.closest('.cart-item').querySelector('[name="updates[]"]');
      const newQuantity = parseInt(quantityInput.value) - 1;
      if (newQuantity > 0) {
        quantityInput.value = newQuantity;
        this.closest('cart-items').updateQuantity(quantityInput.dataset.index, newQuantity, quantityInput.getAttribute('name'));
      }
    });
  }
}

class PlusButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      console.log('plus button', event)
      event.preventDefault();
      const quantityInput = this.closest('.cart-item').querySelector('[name="updates[]"]');
      const newQuantity = parseInt(quantityInput.value) + 1;
      quantityInput.value = newQuantity;
      this.closest('cart-items').updateQuantity(quantityInput.dataset.index, newQuantity, quantityInput.getAttribute('name'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
customElements.define('minus-button', MinusButton);
customElements.define('plus-button', PlusButton);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-items',
      },
      {
        id: 'drawer-name',
        section: document.getElementById('drawer-name').dataset.id,
        selector: '.drawer-cart__wrapper'
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '#cart-icon-bubble'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-footer',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


document.addEventListener('DOMContentLoaded', () => {

  const cartItems = document.querySelectorAll('.cart-item');
  console.log('cartItems', cartItems)
  
  cartItems.forEach((cartItem) => {
    const buttonRemove = cartItem.querySelector('cart-remove-button');
    const minusButton = cartItem.querySelector('minus-button');

    const productTitle = cartItem.querySelector('.cart-item__name').innerText;
    
    let productSize = cartItem.querySelector('.product-option-size');
    if (productSize) productSize = productSize.innerText;
    
    buttonRemove.addEventListener('click', () => {
      console.log('buttonRemove', buttonRemove)
      const removeItemCart = {
        'product_title': productTitle,
        'product_size': productSize
      }
      Shopify.analytics.publish("remove_from_cart", removeItemCart );
    })

    minusButton.addEventListener('click', () => {
      console.log('minusButton', minusButton)
      const reduceItemCart = {
        'product_title': productTitle,
        'product_size': productSize
      }
      Shopify.analytics.publish("reduce_item_quantity", reduceItemCart );
    })

  })

})